import { titleize } from "./classify";
import type { ComponentId, Role } from "./types";

export const COMPONENT_TITLES: { [id in ComponentId]: string } = {
  land: "Land",
  water: "Water",
  landuse: "Parks & land use",
  roads: "Roads",
  buildings: "Buildings",
  borders: "Borders",
  labels: "Labels",
  pois: "Points of interest",
  other: "Other",
};

const SECTION_TITLES: { [section: string]: string } = {
  background: "Background",
  land: "Land",
  landcover: "Land cover",
  water: "Water",
  landuse: "Land use",
  surface: "Road surface",
  outlines: "Road outlines",
  tunnels: "Tunnels",
  rail_airport: "Rail, airport & piers",
  buildings: "Buildings",
  borders: "Borders",
  places: "Place names",
  road_names: "Road names",
  water_names: "Water names",
  pois: "Points of interest",
};

const ROLE_SUFFIX: { [role in Role]: string } = {
  shape: "",
  text: "text",
  halo: "outline",
};

// "Road surface", "Place names: text", "Place names: outline"
export function sectionTitle(section: string, role: Role): string {
  const base = SECTION_TITLES[section] || titleize(section);
  return role === "shape" ? base : `${base}: ${ROLE_SUFFIX[role]}`;
}

const ROAD_NAMES: { [name: string]: string } = {
  highway: "Motorways",
  major: "Main roads",
  minor: "Small roads",
  "minor service": "Service roads",
  link: "Ramps",
  other: "Paths & other roads",
};

// The words people use for what a fine-tune shade colours, by section.
// Anything not listed keeps the name derived from the style.
const FRIENDLY_NAMES: { [section: string]: { [name: string]: string } } = {
  land: { earth: "Land" },
  surface: ROAD_NAMES,
  outlines: ROAD_NAMES,
  tunnels: ROAD_NAMES,
  rail_airport: {
    rail: "Railways",
    runway: "Runways",
    taxiway: "Taxiways",
    pier: "Piers",
  },
  water: { water: "Lakes & sea", river: "Rivers", stream: "Streams" },
  landuse: {
    aerodrome: "Airports",
    runway: "Runways",
    "urban green": "City green",
    pedestrian: "Pedestrian areas",
    pier: "Piers",
    hospital: "Hospitals",
    industrial: "Industrial areas",
    school: "Schools",
    beach: "Beaches",
    zoo: "Zoos",
  },
  places: {
    subplace: "Neighbourhoods",
    locality: "Towns & cities",
    region: "Regions",
    country: "Countries",
  },
  road_names: { major: "Main roads", minor: "Small roads" },
  water_names: { waterway: "Rivers", ocean: "Seas", lakes: "Lakes" },
  borders: { country: "Country borders", boundaries: "Other borders" },
};

export function friendlyName(name: string, section: string): string {
  return FRIENDLY_NAMES[section]?.[name.toLowerCase()] || name;
}
